const WEEKDAYS = [
  'domingo',
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sábado',
];

const MONTHS = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export function accessMeta(now) {
  return {
    weekday: WEEKDAYS[now.getDay()],
    day: String(now.getDate()),
    month: MONTHS[now.getMonth()],
    year: String(now.getFullYear()),
  };
}
